import React, { useMemo } from 'react';
import { CHIPOTLE_CONTENT_LOOK } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/content-look';
import StaticPage from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/static-page';
import usePermissionsChecker from 'helpers/hooks/usePermissionsChecker';
import { staticPageDataMapper } from '../utils';

export interface Props {
  data: any;
  customerGroup: any;
}

const StaticPageTastic: React.FC<Props> = ({ data, customerGroup }) => {
  const { checkItemPermission, filterByTags } = usePermissionsChecker();

  const pageEntry = data?.data?.dataSource?.items?.[0];

  const hasPagePermission = useMemo(() => {
    if (!pageEntry) return true;
    return checkItemPermission(pageEntry, customerGroup);
  }, [pageEntry, customerGroup, checkItemPermission]);

  const mappedData = useMemo(
    () =>
      staticPageDataMapper(data, {
        customerGroup,
        checkItemPermission,
        filterByTags,
      }),
    [data, customerGroup, checkItemPermission, filterByTags],
  );

  if (pageEntry && !hasPagePermission) {
    return null;
  }

  return <StaticPage initialData={mappedData} accordionButtonClassName={CHIPOTLE_CONTENT_LOOK.faqAccordionButtonClassName} />;
};

export default StaticPageTastic;
